import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-2 font-label text-xs text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="whitespace-nowrap transition-colors hover:text-primary-600"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="whitespace-nowrap text-foreground-800">{item.label}</span>
              )}
              {!isLast ? (
                <i className="ri-arrow-right-s-line h-3.5 w-3.5 flex items-center justify-center text-foreground-400"></i>
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}